export const DOCUMENT_TYPE = 'Document'
export const LINK_TYPE = 'Link'
